import axios from "axios";
import router from "../Router";
import { notify } from "@/utils/Notify";

/**
 * Factory-Funktion für eine Axios-Instanz mit einheitlichem Error-Handling
 * @param {string} baseURL - Basis-URL der API
 * @returns {AxiosInstance}
 */
export function createApi(baseURL) {
  const instance = axios.create({
    baseURL,
    defaultURL: process.env.VUE_APP_SERVER_URL,
    withCredentials: true,
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const { status } = error.response;
        switch (status) {
          case 400:
            router.push({ path: "/error/400" });
            break;
          case 401: {
            let startLocation =
              router["history"]["_startLocation"].split("/")[1];
            if (
              router.currentRoute.name !== "Auswertung" &&
              router.currentRoute.name !== "Offerte" &&
              router.currentRoute.name !== "login" &&
              router.currentRoute.name !== "leitsystem" &&
              router.currentRoute.name !== "newpassword" &&
              startLocation !== "newpassword"
            ) {
              router.push({ name: "login" });
            }
            break;
          }

          case 402:
            router.push({ path: "/error/402" });
            break;
          case 403:
            router.push({ path: "/error/403" });
            break;
          case 404:
            router.push({ path: "/error/404" });
            break;
          case 405:
            router.push({ path: "/error/405" });
            break;
          case 420:
            //alert(error.response.data.error || "Ein unbekannter Fehler ist aufgetreten")
            notify({
              type: "error",
              title: "Error",
              text:
                error.response.data.error ||
                "Ein unbekannter Fehler ist aufgetreten",
            });
            break;
          // Weitere Statuscodes...
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
}
